<template>
<div class="body1">
<el-row>
  <router-link to='/authenticationsearch' style="list-style-type:none" tag="li" class="sidebar-nav-link"><el-button type="primary" style="float: right"> 评价申请进度查询 </el-button></router-link>
</el-row>

 <el-form  :model="form1" :rules="rules" ref="form1" label-width="100px">
   <div style="font-size: 35px;font-weight: bold;text-align: center">评价申请</div>
  <el-form-item label="企业名称" prop="eName">
    <el-input v-model="form1.eName"></el-input>
  </el-form-item>
   <el-form-item label="统一社会信用代码" prop="eCode">
    <el-input v-model="form1.eCode"></el-input>
  </el-form-item>
   <el-form-item label="联系人" prop="contacts">
    <el-input v-model="form1.contacts"></el-input>
  </el-form-item>
   <el-form-item label="法定代表人" prop="jperson">
    <el-input v-model="form1.jperson"></el-input>
  </el-form-item>
   <el-form-item label="联系电话" prop="tel">
    <el-input v-model="form1.tel"></el-input>
  </el-form-item>
   <el-form-item label="地址" prop="eAddr">
    <el-input v-model="form1.eAddr"></el-input>
  </el-form-item>

  <el-form-item>
    <el-button type="primary" @click="submitForm()">确定申请</el-button>
  </el-form-item>
</el-form>
   </div>
</template>

<script>
import rootPathssb from '@/api/mainApi'
import { dataPost } from '@/api/index'
export default {
  name: 'evaluation',
  data () {
    return {
      form1: {
        eName: '',
        eCode: '',
        jperson: '',
        tel: '',
        createTime: '',
        updateTime: '',
        contacts: '',
        indSubname: '',
        provName: '',
        cityName: '',
        distName: '',
        eAddr: ''
      },
      rules: {
        eName: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ],
        eCode: [
          { required: true, message: '请输入统一社会信用代码', trigger: 'blur' }
        ],
        jperson: [
          { required: true, message: '请输入法定代表人', trigger: 'blur' }
        ],
        tel: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ],
        contacts: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        eAddr: [
          { required: true, message: '请输入地址', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm (event) {
      var params = new URLSearchParams()
      params.append('eCode', this.form1.eCode)
      params.append('jperson', this.form1.jperson)
      params.append('tel', this.form1.tel)
      params.append('contacts', this.form1.contacts)
      params.append('eAddr', this.form1.eAddr)
      params.append('eName', this.form1.eName)
      dataPost(rootPathssb.rootPath + '/app/add', params).then(function (response) {
        if (response.data.result === 1) {
          alert('保存成功')
          this.$router.push({path: '/'})
          console.log('cg')
        };

        console.log(response.data)
      }).catch(function (error) {
        console.log(error); console.log(2222222222); alert('失败')
      })
    }
  }
}
</script>

<style scoped>
.body1{
  width:600px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/computer/evaluation.vue